import { cn } from '@/utils/cn';
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  helperText?: string;
  label?: React.ReactNode;
  id?: string;
  testId?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, helperText, label, id, testId, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-xs font-semibold text-ui-body mb-1"
          >
            {label}
          </label>
        )}
        <input
          type={type}
          id={inputId}
          data-testid={testId}
          className={cn(
            'w-full px-4 py-2 border rounded-sm shadow-none focus:outline-none focus:ring-1 focus:ring-ui-primary/20 transition-all placeholder:text-ui-muted text-sm',
            props.disabled
              ? 'bg-ui-surface-soft text-ui-muted border-ui-hairline cursor-not-allowed'
              : 'bg-ui-surface-card text-ui-ink',
            error
              ? 'border-ui-error focus:ring-ui-error/20 focus:border-ui-error'
              : 'border-ui-hairline focus:border-ui-primary',
            className
          )}
          ref={ref}
          {...props}
        />
        {helperText && (
          <p className={cn('mt-1 text-xs', error ? 'text-ui-error' : 'text-ui-muted text-[10px]')}>
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
